/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Eric Chu

 Description:
*/

/*_*/
export var GLOBAL_SEARCH_OPEN = 'GLOBAL_SEARCH_OPEN';
export var GLOBAL_SEARCH_CLOSE = 'GLOBAL_SEARCH_CLOSE';
export var GLOBAL_SEARCH_TOGGLE = 'GLOBAL_SEARCH_TOGGLE';
export var GLOBAL_SEARCH_SET_URL = 'GLOBAL_SEARCH_SET_URL';
export var GLOBAL_SEARCH_NAVIGATE = 'GLOBAL_SEARCH_NAVIGATE';
export var GLOBAL_SEARCH_SET_VALUE = 'GLOBAL_SEARCH_SET_VALUE';
export var GLOBAL_SEARCH_SET_MODE = 'GLOBAL_SEARCH_SET_MODE';
export var GLOBAL_SEARCH_FETCH_RESULTS = 'GLOBAL_SEARCH_FETCH_RESULTS';
export var GLOBAL_SEARCH_FETCH_SUGGESTIONS = 'GLOBAL_SEARCH_FETCH_SUGGESTIONS';
export var GLOBAL_SEARCH_SET_SUGGESTIONS = 'GLOBAL_SEARCH_SET_SUGGESTIONS';
export var GLOBAL_SEARCH_SET_RESULTS = 'GLOBAL_SEARCH_SET_RESULTS';
export var GLOBAL_SEARCH_CLEAR_RESULTS = 'GLOBAL_SEARCH_CLEAR_RESULTS';
export var GLOBAL_SEARCH_CLEAR_SUGGESTIONS = 'GLOBAL_SEARCH_CLEAR_SUGGESTIONS ';
export var openGlobalSearch = function openGlobalSearch() {
  return {
    type: GLOBAL_SEARCH_OPEN
  };
};
export var closeGlobalSearch = function closeGlobalSearch() {
  return {
    type: GLOBAL_SEARCH_CLOSE
  };
};
export var toggleGlobalSearch = function toggleGlobalSearch(open) {
  return {
    type: GLOBAL_SEARCH_TOGGLE,
    open: open
  };
};
export var setGlobalSearchUrl = function setGlobalSearchUrl(searchUrl) {
  return {
    type: GLOBAL_SEARCH_SET_URL,
    searchUrl: searchUrl
  };
};
export var navigateGlobalSearch = function navigateGlobalSearch(payload, url) {
  return {
    type: GLOBAL_SEARCH_NAVIGATE,
    payload: payload,
    url: url
  };
};
export var setGlobalSearchValue = function setGlobalSearchValue(value) {
  return {
    type: GLOBAL_SEARCH_SET_VALUE,
    value: value
  };
};
export var setGlobalSearchMode = function setGlobalSearchMode(mode) {
  return {
    type: GLOBAL_SEARCH_SET_MODE,
    mode: mode
  };
};
export var fetchGlobalSearchResults = function fetchGlobalSearchResults() {
  return {
    type: GLOBAL_SEARCH_FETCH_RESULTS
  };
};
export var fetchGlobalSearchSuggestions = function fetchGlobalSearchSuggestions() {
  return {
    type: GLOBAL_SEARCH_FETCH_SUGGESTIONS
  };
};
export var setGlobalSearchSuggestions = function setGlobalSearchSuggestions(suggestions) {
  return {
    type: GLOBAL_SEARCH_SET_SUGGESTIONS,
    suggestions: suggestions
  };
};
export var setGlobalSearchResults = function setGlobalSearchResults(searchResultsBean) {
  return {
    type: GLOBAL_SEARCH_SET_RESULTS,
    searchResultsBean: searchResultsBean
  };
};
export var clearGlobalSearchResults = function clearGlobalSearchResults() {
  return {
    type: GLOBAL_SEARCH_CLEAR_RESULTS
  };
};
export var clearGlobalSearchSuggestions = function clearGlobalSearchSuggestions() {
  return {
    type: GLOBAL_SEARCH_CLEAR_SUGGESTIONS
  };
};